export default "__VITE_ASSET__9y3qhy16__"